import React, { useMemo, useRef, useState } from "react";

import { Popup } from "semantic-ui-react";

import moment from "moment";

import LoadingIcon from "react-lib/apps/HISV3/HCU/LoadingIcon";
import ModLotNoExp from "react-lib/apps/HISV3/TPD/ModLotNoExp";

import { formatDate } from "react-lib/utils/dateUtils";

type ButtonSupplyLotNoProps = {
  onEvent: (e: any) => any;
  setProp: (key: string, value: any, callback?: () => void) => any;
  data: Record<string, any>;
  lotNoExpList?: Record<string, any>[];
  orderPerformDiv?: number;
  status: string;
  buttonLoadCheck: any;
  errorMessage: any;
  languageUX: "en" | "th";
};

const IMAGES = {
  lotNoBlue: "/static/images/supply/lot-no-blue.png",
  lotNoGrey: "/static/images/supply/lot-no-grey.png",
};

const ButtonSupplyLotNo = (props: ButtonSupplyLotNoProps) => {
  const [openModLotNo, setOpenModLotNo] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const abortController = useRef<AbortController>(null);

  const allowedEdit = useMemo(
    () => ["CHECKED", "PRINTED", "REQUESTED"].includes(props.status),
    [props.status]
  );

  const formattedItems = useMemo(() => {
    const items = props.lotNoExpList ?? [];
    const filteredItems = items.filter((item) => item.plan_id);

    return filteredItems.map((item) => ({
      label: `Lot. ${item.storage.name} [exp.${formatDate(moment(item.lot.exp_datetime))}]`,
      qty: Math.abs(item.plan_quantity),
      unit: props.data.stock_unit,
    }));
  }, [props.data.stock_unit, props.lotNoExpList]);

  const handleClickLotNo = () => {
    if (allowedEdit) {
      setOpenModLotNo(true);
    }
  };

  const handleCloseModLotNo = () => {
    setOpenModLotNo(false);
  };

  const handleOpen = async () => {
    if (isLoading || allowedEdit) {
      return;
    }

    setIsLoading(true);

    const result = await props.onEvent({
      message: "GetLotNoExp",
      params: {
        abortController,
        orderItem: props.data.id,
        orderPerformDiv: props.orderPerformDiv,
        productId: props.data.product,
        type: "supply",
      },
    });

    if (!result) {
      handleClose();

      return;
    }

    setOpen(true);
    setIsLoading(false);
  };

  const handleClose = () => {
    setOpen(false);
    setIsLoading(false);

    props.setProp("lotNoExpList", []);

    abortController.current?.abort();
  };

  return (
    <>
      <Popup
        style={{ border: "1px solid #97c5e4", minWidth: "max-content" }}
        open={allowedEdit ? false : open}
        position="bottom left"
        onClose={handleClose}
        onOpen={handleOpen}
        content={
          <div>
            <div style={{ fontWeight: "bold" }}>Lot no. [exp.]</div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "max-content 1fr",
              }}
            >
              {formattedItems.map((item, index) => (
                <React.Fragment key={`plan-${index}`}>
                  <label style={{ paddingRight: "3rem" }}>{item.label}</label>
                  <label>
                    จำนวน {item.qty} {item.unit}
                  </label>
                </React.Fragment>
              ))}
            </div>
          </div>
        }
        trigger={
          <div>
            <LoadingIcon
              style={{ width: "45px" }}
              img={allowedEdit ? IMAGES.lotNoBlue : IMAGES.lotNoGrey}
              loading={isLoading}
              onClick={handleClickLotNo}
            />
          </div>
        }
      />

      <ModLotNoExp
        onEvent={props.onEvent}
        setProp={props.setProp}
        data={props.data}
        lotNoExpList={props.lotNoExpList}
        open={openModLotNo}
        orderPerformDiv={props.orderPerformDiv}
        type="supply"
        buttonLoadCheck={props.buttonLoadCheck}
        errorMessage={props.errorMessage}
        languageUX={props.languageUX}
        onClose={handleCloseModLotNo}
      />
    </>
  );
};

ButtonSupplyLotNo.displayName = "ButtonSupplyLotNo";

export default React.memo(ButtonSupplyLotNo);
